import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import AppLayout from '../../component/appLayout';
import {
  HeaderInbox,
  MainHeader,
  InboxMSG,
  LeftSide,
  Div,
  Heading,
  Title,
  Menu,
  Overlay,
  Empty,
  Content,
  InboxPreviewAction,
  ActionSection,
  DetailPreview,
  PreviewSection,
  DropDiv,
  IconDiv,
  InboxContainer
} from './styles';
import {
  deleteNotification,
  loadInboxData,
  updateNotification,
  clearAllNotifications
} from '../../services/inboxServices';
import {
  COMMENT_TYPE,
  EMPTY_STATE_SIZE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  INBOX_FILTER_TYPE,
  NOTIFICATION_TYPE,
  ONESIGNAL_APP_ID,
  STATUS_TYPE,
  TAB_BUTTON_TYPE,
  ENABLE_NOTIFICATIONS_TEXT,
  IMAGE_CONTENT_MARKERS,
  ICON_SIZE
} from '../../global/constants';
import { useHistory } from 'react-router-dom';
import {
  getCurrentDomain,
  getUrlParam,
  isElectronApp,
  isEmpty,
  getTomorrowAt9am,
  getNextWeekISO,
  isRescheduleExpired
} from '../../helpers/common';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { ROUTES } from '../../routes/urls';
import { initPushNotification } from '../../services/appService';
import { captureException } from '../../services/logService';
import { CustomWindow } from '../../interfaces/OneSignalInterface';
import Modal from '../../component/modals/modal';
import DeleteModal from '../../component/modals/deleteModal';
import InboxLoading from '../../component/loading/inboxLoading';
import { useMobileDevice } from '../../global/useMobile';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { TASK_ANALYTICS } from '../../global/analyticsConstants';
import TaskDetailPreview from '../../component/modals/taskDetailPreviewModal';
import InboxCard from './inboxCard';
import { useSwipeGesture } from '../../hooks/inbox/useSwipeGesture';
import { Dropdown, DropdownItem } from '../../component/dropdown';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { NotificationModel } from '../../mobx/models/notification';
import useNotificationNavigation from '../../hooks/inbox/useNotificationNavigation';
import { useHotkeys } from 'react-hotkeys-hook';
import ResponsiveHeader from '../../component/responsiveHeader';
import { menuInboxArchiveItems, menuInboxFilterItems, menuInboxFilterItemsResponsive } from '../../global/row';
import { TaskModel } from '../../mobx/models/task';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import { menuItems } from '../../helpers/list';
import { TaskGroupInterface } from '../../interfaces/TaskInterface';
import { dispatchTaskUpdates, onUpdateStatus } from '../../services/taskActionService';
import ConfirmationModal from '../../component/modals/confirmationModal';
import { updateTaskDetails, createNewComment } from '../../services/taskServices';
import useSnooze from '../../hooks/inbox/useSnooze';
import Tabs from '../../component/tabs';
import IconButton from '../../component/button/iconButton';
import { DarkImages, LightImages } from '../../assets/images/images';
import EmptyStateV2 from '../../component/emptyState';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ImageKey } from '../../component/image';
import DesktopNotificationCard from './desktopNotificationCard';
import NotificationList from './notificationList';
import InboxActionButtons from './inboxActionButtons';
import { setLastReadForDiscussion } from '../../services/chatMessageSyncService';
dayjs.extend(relativeTime);

declare const window: CustomWindow;
const Inbox: React.FC = () => {
  //Refs
  const buttonRef = useRef<React.RefObject<HTMLDivElement>[]>([]);

  //States
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [overDueCardDismissed, setOverDueCardDismissed] = useState(false);
  const [notificationCardDismiss, setNotificationCardDismiss] = useState(false);
  const [desktopCardDismiss, setDesktopCardDismiss] = useState(false);
  const [messageCardDismissed, setMessageCardDismissed] = useState(false);
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState('');
  const hoveredItemRef = useRef<string | null>(null);
  const [subtaskConfirmData, setSubtaskConfirmData] = useState<{
    task: TaskModel;
    status: StatusListInterface;
    previousStatus: StatusListInterface;
  } | null>(null);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState<'ok' | 'cancel' | null>(null);
  const [calendarDate, setCalendarDate] = useState(new Date());

  //Mobx store variables
  const { notificationStore, workspaceStore, taskStore, currentUser, appStore, chatMessageStore } = rootStore;
  const { notifications, filteredNotifications } = notificationStore;
  const { currentTask: taskDetails } = taskStore;
  const { currentWorkspace } = workspaceStore;
  const workspace_id = currentWorkspace?.id || '';
  const { themeMode } = appStore || {};
  const { unreadMessagesCount } = chatMessageStore;
  const {
    total: unreadTotal,
    groupNamesText: unreadFromText,
    unreadGroupIds
  } = unreadMessagesCount || {
    total: 0,
    groupNamesText: '',
    unreadGroupIds: []
  };
  //Other variable
  const mobile = useMobileDevice();
  const history = useHistory();
  const filterType = Number(getUrlParam(history.location.search, 'type'));

  const {
    selectedTask,
    selectedTaskIndex,
    isTaskDetailOpen,
    buttonDisable,
    isRearranging: navIsRearranging,
    updateButtonState,
    handleNextNotification,
    handlePreviousNotification,
    handleArrowClick,
    handleCloseTaskDetail,
    setIsTaskDetailOpen,
    setSelectedTask,
    setSelectedTaskIndex
  } = useNotificationNavigation(filteredNotifications || []);

  const {
    swipedItemId,
    touchStartX,
    touchEndX,
    deletingId,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    resetSwipe,
    setDeletingId
  } = useSwipeGesture(mobile);

  const {
    openDropdownId,
    dropdownRefCalendar,
    handleClick,
    handleTimeChange,
    onClickSnooze,
    onCancelSnooze,
    onClickSnoozeIcon,
    onDateChange,
    subDropdownOpen,
    setSubDropdownOpen,
    handleSubDropdownOpen
  } = useSnooze(filteredNotifications, notificationStore, buttonRef, mobile, resetSwipe, setIsTaskDetailOpen);

  // Check if the notification description contains markers indicating it has image content
  const isImageDescription = (description?: string | null): boolean => {
    if (!description) return false;
    return IMAGE_CONTENT_MARKERS.some((className) => description.includes(className));
  };

  // images source - using imageKey pattern like image component
  const imageSource = useCallback(
    (imageKey: ImageKey) => (themeMode?.theme === 'dark' ? DarkImages[imageKey] : LightImages[imageKey]),
    [themeMode?.theme]
  );

  const snoozeMenuItems = useMemo(
    () => [
      {
        key: 'today',
        iconName: 'today-snooze-icon',
        label: 'Today',
        RightSideLabel: dayjs().hour(15).minute(0).second(0).format('ddd, h:mm A')
      },
      {
        key: 'tomorrow',
        iconName: 'tomorrow-icon',
        label: 'Tomorrow',
        RightSideLabel: dayjs().add(1, 'day').hour(9).minute(0).second(0).format('ddd, h:mm A')
      },
      {
        key: 'this-Week',
        iconName: 'thisweek-snooze-icon',
        label: 'This Week'
      },
      {
        key: 'next-Week',
        iconName: 'next-week-icon',
        label: 'Next Week'
      }
    ],
    []
  );

  const overDueTime = useMemo(() => UserPreferenceSingleton.getInstance().getOverDueRescheduleTime() || {}, []);
  const notificationRescheduleTime: string = UserPreferenceSingleton.getInstance().getNotificationReschedule() || '';
  const deskTopNotificationRescheduleTime: string =
    UserPreferenceSingleton.getInstance().getDesktopNotificationReschedule() || '';
  const messageUnreadTime = UserPreferenceSingleton.getInstance().getMessageUnreadRescheduleTime() || {};
  const overDueRescheduleTime = overDueTime[workspace_id] || '';
  const messageUnreadRescheduleTime = messageUnreadTime[workspace_id] || '';
  const isTeamcampDomain = getCurrentDomain() === 'dash.teamcamp.app';
  const isShowNotificationCard =
    isRescheduleExpired(notificationRescheduleTime) &&
    !notificationCardDismiss &&
    permissionStatus !== '' &&
    permissionStatus !== 'denied' &&
    permissionStatus !== 'granted' &&
    isTeamcampDomain;

  const isShowDesktopNotification =
    !isElectronApp() && !mobile && !desktopCardDismiss && isRescheduleExpired(deskTopNotificationRescheduleTime);

  const overDueTasksCount = useMemo(() => {
    const delayedTasks =
      currentUser?.tasks?.filter(
        (task) => task?.dueDate && dayjs(task.dueDate).startOf('day').isBefore(dayjs().startOf('day'))
      ) || [];
    return delayedTasks.length || 0;
  }, [currentUser?.tasks]);

  const isShowOverdueCard =
    isRescheduleExpired(overDueRescheduleTime) && !overDueCardDismissed && (overDueTasksCount || 0) > 0;

  // show message card logic mirrors overdue card
  const isShowMessageCard =
    isRescheduleExpired(messageUnreadRescheduleTime) && !messageCardDismissed && (unreadTotal || 0) > 0;

  const isShowEmptyState =
    !loading &&
    filteredNotifications?.length === 0 &&
    !isShowOverdueCard &&
    !isShowDesktopNotification &&
    !isShowMessageCard &&
    !(isShowNotificationCard && isTeamcampDomain);

  const isInboxText =
    !loading &&
    notifications?.length === 0 &&
    !isShowOverdueCard &&
    !isShowDesktopNotification &&
    !isShowMessageCard &&
    !(isShowNotificationCard && isTeamcampDomain);

  const unreadTitle = `${unreadTotal} unread message${unreadTotal !== 1 ? 's' : ''}`;
  const unreadText = unreadFromText ? `From ${unreadFromText}` : '';

  // light and dark mode github icon
  const githubSvgIcon = themeMode?.theme === 'dark' ? 'github-inbox-dark-icon' : 'github-inbox-light-icon';

  // open delete model
  const OpenDeleteModel = useCallback(() => {
    setDeleteModelOpen(true);
  }, []);

  // close delete model
  const closeDeleteModel = useCallback(() => {
    setDeleteModelOpen(false);
  }, []);

  // load initial data
  const loadData = useCallback(async () => {
    if (isEmpty(workspace_id)) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      notificationStore.setFilterType(filterType);
      await loadInboxData();
    } catch (error) {
      captureException(error);
    } finally {
      setLoading(false);
    }
  }, [filterType, notificationStore, workspace_id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  //handle inbox tab change
  const inboxTabChange = useCallback(
    (filterType: number) => {
      notificationStore.setFilterType(filterType);
      history.push(`${history.location.pathname}?type=${filterType}`);
    },
    [notificationStore, history]
  );

  // Check if task exists in the local store
  const checkIfTaskExists = useCallback((notification: NotificationModel): boolean => {
    if (!notification.taskId) return false;
    return !!notification.task; // Using the task getter from NotificationModel
  }, []);

  // Show error message for deleted task
  const showTaskDeletedMessage = useCallback(() => {
    rootStore.alertNotificationStore.setErrorMessage(
      "The task you're trying to open has been deleted or is no longer available."
    );
  }, []);

  // redirect to task detail page
  const onClickInboxItem = useCallback(
    async (event: React.MouseEvent<HTMLDivElement>, notification: NotificationModel, index: number) => {
      if (!notification) return;
      const handleUpdateNotification = () => {
        updateNotification(notification.id);
      };

      const handleMarkTaskAsRead = () => {
        const model = (notification as NotificationModel)?.markAsRead
          ? (notification as NotificationModel)
          : notifications.find((n) => n.id === notification.id);
        model?.markAsRead();
      };

      const trackViewAnalytics = () => {
        trackAnalyticActivity(TASK_ANALYTICS.VIEW, { source: 'inbox', title: notification?.description || '' });
      };

      const handleTaskDetailRedirection = () => {
        setIsTaskDetailOpen(true);
        setSelectedTask(notification);
        setSelectedTaskIndex(index);
        updateButtonState(filteredNotifications, notification, index);
      };

      const navigateToTaskDetails = () => {
        if (notification.projectId && notification.taskId) {
          // Check if task exists before navigating
          if (!checkIfTaskExists(notification)) {
            showTaskDeletedMessage();
            return;
          }
          rootStore.taskStore.setCurrentTask(notification.taskId);
          history.push(
            ROUTES.TASK_DETAILS.replace(':id', notification.task?.projectId || '').replace(
              ':taskId',
              notification.taskId || ''
            )
          );
        }
      };

      const navigateToProjectDetails = () => {
        if (notification.projectId) {
          rootStore.projectStore.setCurrentProject(notification.projectId);
          history.push(ROUTES.PROJECT_TASKS.replace(':id', notification.projectId || ''));
        }
      };

      const navigateToMessages = () => {
        const path = mobile
          ? `${ROUTES.NAVBARMESSAGE_DETAILS_MOBILE}?chatGroup=${notification.projectId}`
          : `${ROUTES.NAVBARMESSAGE}?chatGroup=${notification.projectId}`;
        history.push(path);
      };

      if (
        [
          NOTIFICATION_TYPE.COMMENT,
          NOTIFICATION_TYPE.TASK,
          NOTIFICATION_TYPE.INVITE,
          NOTIFICATION_TYPE.PROJECT_INVITE,
          NOTIFICATION_TYPE.VIEWS
        ].includes(notification.type)
      ) {
        handleUpdateNotification();

        if (notification.type === NOTIFICATION_TYPE.VIEWS) {
          history.push(ROUTES.VIEW_ROUTE.replace(':viewId', notification.projectId || ''));
        } else if (notification.projectId && notification.taskId) {
          // For task-related notifications, check if task exists
          if (!checkIfTaskExists(notification)) {
            showTaskDeletedMessage();
            return;
          }

          if (!notification.isRead) {
            handleMarkTaskAsRead();
          }
          trackViewAnalytics();
          if (event.metaKey || event.ctrlKey) {
            handleTaskDetailRedirection();
          } else {
            navigateToTaskDetails();
          }
        } else if (notification.projectId && isEmpty(notification.companyId)) {
          if (notification.type === NOTIFICATION_TYPE.COMMENT) {
            navigateToMessages();
          } else {
            navigateToProjectDetails();
          }
        }
      }
    },
    [
      notifications,
      updateButtonState,
      filteredNotifications,
      history,
      mobile,
      showTaskDeletedMessage,
      checkIfTaskExists,
      setIsTaskDetailOpen,
      setSelectedTask,
      setSelectedTaskIndex
    ]
  );

  // manage read icon click
  const onClickReadIcon = useCallback(
    async (notification: NotificationModel | { id: string; isRead: boolean }, e?: React.SyntheticEvent | undefined) => {
      e?.stopPropagation();
      // Reset swipe animation to work only in responsive screen
      if (mobile) resetSwipe();

      if (notification.isRead) return;
      const model = (notification as NotificationModel)?.markAsRead
        ? (notification as NotificationModel)
        : notifications.find((n) => n.id === notification.id);
      model?.markAsRead();
      try {
        await updateNotification(notification.id);
      } catch (error) {
        captureException(error);
      }
      setIsTaskDetailOpen(false);
    },
    [mobile, notifications, resetSwipe, setIsTaskDetailOpen]
  );

  // clear all notification
  const clearAllMessages = useCallback(async () => {
    try {
      setButtonLoading(true);
      const response = await clearAllNotifications();
      if (response) {
        closeDeleteModel();
        rootStore.notificationStore.setNotifications([]);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setButtonLoading(false);
    }
  }, [closeDeleteModel]);

  useEffect(() => {
    initPushNotification();
  }, []);

  // get notification permission
  const getNotificationPermission = useCallback(async () => {
    window.OneSignal?.push(function () {
      if (window.Notification?.permission) setPermissionStatus(window.Notification.permission);
    });
  }, []);

  // manage notification permission change
  const handlePermissionChange = useCallback((newPermission: { to: string }) => {
    if (newPermission?.to === 'default') UserPreferenceSingleton.getInstance().setOneSignalInit(false);
    setPermissionStatus(newPermission?.to);
  }, []);

  useEffect(() => {
    if (window.OneSignal) {
      window.OneSignal.push(() => {
        window.OneSignal?.on('notificationPermissionChange', handlePermissionChange);
      });
      getNotificationPermission();
      return () => {
        window.OneSignal?.push(() => {
          window.OneSignal?.off('notificationPermissionChange', handlePermissionChange);
        });
      };
    } else {
      setPermissionStatus('denied');
    }
  }, [getNotificationPermission, handlePermissionChange]);

  // for dismiss overdue card
  const onClickDismiss = useCallback(() => {
    const tomorrow = getTomorrowAt9am();
    const overDueTimeObject = {
      ...overDueTime,
      [workspace_id]: tomorrow.toISOString()
    };
    UserPreferenceSingleton.getInstance().setOverDueRescheduleTime(overDueTimeObject);
    setOverDueCardDismissed(true);
  }, [overDueTime, workspace_id]);

  // for enable notification overdue card
  const onEnableNotification = useCallback(async () => {
    try {
      window.OneSignal?.push(function () {
        window.OneSignal?.init({
          appId: ONESIGNAL_APP_ID
        });
      });
      window.OneSignal?.push(function () {
        window.OneSignal?.push(function () {
          window.OneSignal?.push(['registerForPushNotifications']);
        });
      });
    } catch (e) {
      captureException(e);
    }
  }, []);

  // for disable (no enable) notification
  const onClickNoEnableNotification = useCallback(() => {
    const rescheduleDate = getNextWeekISO();
    UserPreferenceSingleton.getInstance().setNotificationReschedule(rescheduleDate);
    setNotificationCardDismiss(true);
  }, []);

  // On click dismiss desktop notification
  const onDismissDesktopNotification = useCallback(() => {
    const rescheduleDate = getNextWeekISO();
    UserPreferenceSingleton.getInstance().setDesktopNotificationReschedule(rescheduleDate);
    setDesktopCardDismiss(true);
  }, []);

  // for dismiss message unread card (persist per workspace + local hide)
  const onClickMessageDismiss = useCallback(() => {
    const tomorrow = getTomorrowAt9am();
    const existing = UserPreferenceSingleton.getInstance().getMessageUnreadRescheduleTime() || {};
    const updated = { ...existing, [workspace_id]: tomorrow.toISOString() } as Record<string, string>;
    UserPreferenceSingleton.getInstance().setMessageUnreadRescheduleTime(updated);
    setMessageCardDismissed(true);
  }, [workspace_id]);

  // mark all message groups as read - use service and store ids
  const onMarkAllMessagesRead = useCallback(async () => {
    try {
      const ids = unreadMessagesCount?.unreadGroupIds || [];
      if (!ids.length) return;
      await Promise.allSettled(ids.map((id: string) => setLastReadForDiscussion(id)));
    } catch (e) {
      captureException(e);
    }
  }, [unreadMessagesCount?.unreadGroupIds]);

  // handle delete icon click
  const onClickDeleteIcon = useCallback(
    async (notification: { id: string; isRead: boolean }, e?: React.SyntheticEvent | undefined) => {
      e?.stopPropagation();

      const removeAndNavigate = (list: NotificationModel[]) => {
        const wasRemoved = !list.some((item) => item.id === notification.id);
        if (wasRemoved) notificationStore.removeNotifications([notification.id]);
        if (buttonDisable.forward && buttonDisable.backward) setIsTaskDetailOpen(false);
        else if (buttonDisable.forward) handlePreviousNotification(list);
        else handleNextNotification(list);
      };

      if (mobile) {
        setDeletingId(notification.id); // Start animation
        // Reset swipe animation to work only in responsive screen
        resetSwipe();
        // for animation in responsive screen  added setTimeOut
        setTimeout(async () => {
          const updatedList = (filteredNotifications || []).filter((item) => item.id !== notification.id);
          removeAndNavigate(updatedList);
          await deleteNotification(notification?.id);
          setDeletingId(null);
        }, 200); // Animation duration
      } else {
        // Desktop: delete immediately, no animation
        const updatedList = (filteredNotifications || []).filter((item) => item.id !== notification.id);
        removeAndNavigate(updatedList);
        await deleteNotification(notification?.id);
      }
    },
    [
      resetSwipe,
      mobile,
      filteredNotifications,
      buttonDisable.forward,
      buttonDisable.backward,
      notificationStore,
      handlePreviousNotification,
      handleNextNotification,
      setIsTaskDetailOpen,
      setDeletingId
    ]
  );

  const onHoverChange = useCallback((id: string | null) => {
    hoveredItemRef.current = id;
  }, []);

  useHotkeys(
    'e',
    (e) => {
      if (hoveredItemRef.current && filteredNotifications) {
        const currentIndex = filteredNotifications.findIndex(
          (notification) => notification.id === hoveredItemRef.current
        );

        if (currentIndex !== -1) {
          // Archive the current item
          const currentItem = filteredNotifications[currentIndex];
          onClickDeleteIcon(currentItem);

          // Find the next item to select
          let nextItem = null;

          // If there are items after the current one, select the next one
          if (currentIndex < filteredNotifications.length - 1) {
            nextItem = filteredNotifications[currentIndex + 1];
          }
          // If it's the last item and there are items before it, select the previous one
          else if (currentIndex > 0) {
            nextItem = filteredNotifications[currentIndex - 1];
          }

          // Set the next item as active
          hoveredItemRef.current = nextItem?.id || null;
        }
      }
    },
    { enabled: true }
  );

  const checkSubtaskStatus = useCallback((task: TaskModel): boolean => {
    return task.subTasks?.every((subTask) => subTask?.status !== false) ?? true;
  }, []);
  const onClickUpdateStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        setIsOpenConfirmationModal(true);
        setSubtaskConfirmData({ task, status, previousStatus });
        return;
      }
      onUpdateStatus(task, status, previousStatus, false);
    },
    [checkSubtaskStatus]
  );

  const closeConfirmationModal = useCallback(() => {
    setIsOpenConfirmationModal(false);
    setSubtaskConfirmData(null);
  }, []);

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!subtaskConfirmData?.task) return;
    try {
      setConfirmationLoading('ok');
      const { task: currentTask, status, previousStatus } = subtaskConfirmData;
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true);
        loadData();
      }
    } catch (error) {
      captureException(error);
    } finally {
      setConfirmationLoading(null);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, loadData, subtaskConfirmData]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!subtaskConfirmData?.task) return;
    try {
      setConfirmationLoading('cancel');
      const { task: currentTask, status, previousStatus } = subtaskConfirmData;
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setConfirmationLoading(null);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, subtaskConfirmData]);

  const onClickUpdatePriority = useCallback(async (task: TaskModel, key: number) => {
    const previousPriority = task?.priority;
    task.setPriority(key);
    const payloadTask = { priority: Number(key), projectId: task?.projectId };
    const result = await updateTaskDetails(task?.id, payloadTask);
    const commentResult = await createNewComment(task?.id, {
      Type: COMMENT_TYPE.CHANGE_PRIORITY,
      PreviousPriority: previousPriority,
      Priority: Number(key)
    });
    if (result && commentResult) {
      trackAnalyticActivity(TASK_ANALYTICS.PRIORITY_CHANGED);
    }
  }, []);

  const onClickGroup = useCallback(async (task: TaskModel, group: TaskGroupInterface) => {
    const previousGroup = task?.project?.taskGroups?.find((x) => x?.id === task?.groupId);
    const payloadTask = { groupId: group?.id, projectId: task?.projectId };
    const result = await updateTaskDetails(task?.id, payloadTask);
    const commentResult = await createNewComment(task?.id, {
      Type: COMMENT_TYPE.CHANGE_GROUP,
      PreviousGroup: previousGroup?.name,
      Group: group?.name
    });
    if (result && commentResult) {
      task?.setGroup(group?.id);
      trackAnalyticActivity(TASK_ANALYTICS.GROUP_CHANGED);
    }
  }, []);

  const renderMoreMenu = (
    <DropDiv>
      <Dropdown
        modalTitle='Manage Notifications'
        activeClassName='active-state'
        content={
          <IconButton
            iconName='three-dots-horizontal-icon'
            size={mobile ? ICON_BUTTON_SIZE.LARGE : ICON_BUTTON_SIZE.SMALL}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            fill='var(--text-secondary)'
          />
        }
        trigger='click'>
        {menuInboxArchiveItems.map((item) => {
          return <DropdownItem key={item?.key} label={item?.label} onClick={OpenDeleteModel} />;
        })}
      </Dropdown>
    </DropDiv>
  );

  const onClickViewAllMessages = useCallback(() => {
    history.push(`${ROUTES.NAVBARMESSAGE}?chatGroup=${unreadGroupIds[0] || ''}`);
  }, [history, unreadGroupIds]);

  const activeFilterType = filterType || INBOX_FILTER_TYPE.ALL;

  return (
    <>
      <AppLayout isInbox={true} isTaskDetailPreviewOpen={isTaskDetailOpen}>
        <InboxContainer isEmpty={isShowEmptyState}>
          {!mobile ? (
            <MainHeader>
              <HeaderInbox>
                {!isInboxText && (
                  <LeftSide>
                    <Heading>
                      <IconDiv>
                        <SVGIcon
                          name='inbox-icon'
                          width={ICON_SIZE.LG}
                          height={ICON_SIZE.LG}
                          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                          fill='var(--brand-primary)'
                        />
                      </IconDiv>
                      <Title>Inbox</Title>
                    </Heading>
                  </LeftSide>
                )}
                {notifications?.length > 0 && (
                  <>
                    <Div>
                      <Menu>
                        {menuInboxFilterItems.map((item, index) => {
                          return (
                            <Tabs
                              key={index}
                              variant={TAB_BUTTON_TYPE.STANDARD}
                              title={item.label}
                              isActive={item?.key === activeFilterType}
                              onClick={() => inboxTabChange(item?.key)}
                            />
                          );
                        })}
                      </Menu>
                      {renderMoreMenu}
                    </Div>
                  </>
                )}
              </HeaderInbox>
            </MainHeader>
          ) : (
            <ResponsiveHeader
              noMargin={true}
              title='Inbox'
              leftElement={
                notifications?.length > 0 && (
                  <>
                    {renderMoreMenu}
                    <Dropdown
                      modalTitle='Filters'
                      content={
                        <IconButton
                          iconName='filter-icon'
                          size={ICON_BUTTON_SIZE.LARGE}
                          variant={ICON_BUTTON_TYPE.TERTIARY}
                        />
                      }
                      trigger='click'>
                      {menuInboxFilterItemsResponsive.map((item) => {
                        return (
                          <DropdownItem
                            key={item?.key}
                            label={item?.label}
                            isSelected={item?.key === activeFilterType}
                            onClick={() => inboxTabChange(item?.key)}
                          />
                        );
                      })}
                    </Dropdown>
                  </>
                )
              }
            />
          )}

          {/* Loading state */}
          {loading && filteredNotifications?.length === 0 && <InboxLoading />}

          {/* Empty state */}
          {isShowEmptyState && (
            <Empty>
              <EmptyStateV2
                size={EMPTY_STATE_SIZE.MEDIUM}
                title='Your inbox is empty for now'
                description={`This is where you'll receive notifications for all types of activity. Enjoy your clutter-free inbox!`}
                imageUrl={'inbox_empty'}
              />
            </Empty>
          )}
          {(filteredNotifications?.length > 0 ||
            isShowOverdueCard ||
            isShowNotificationCard ||
            isShowDesktopNotification ||
            isShowMessageCard) && (
            <InboxMSG>
              {/* Desktop app notification card */}
              {isShowDesktopNotification && (!loading || filteredNotifications?.length > 0) && (
                <DesktopNotificationCard onDismiss={onDismissDesktopNotification} />
              )}

              {/* message unread card */}
              {isShowMessageCard && (!loading || filteredNotifications?.length > 0) && (
                <InboxCard
                  iconName='message-unread-icon'
                  title={unreadTitle}
                  text={unreadText}
                  buttonTitle='View Messages'
                  secondaryButtonTitle='Mark all as read'
                  buttonAction={onClickViewAllMessages}
                  secondaryButtonAction={onMarkAllMessagesRead}
                  dismissAction={onClickMessageDismiss}
                  className='notification-card'
                  backgroundUrl={imageSource('message_unread')}
                />
              )}

              {isShowOverdueCard && (!loading || filteredNotifications?.length > 0) && (
                <InboxCard
                  iconName='overdue-icon'
                  title={`You have ${overDueTasksCount} overdue task!`}
                  text={`It's good to be on schedule. Try to finish your overdue task or reschedule it.`}
                  buttonTitle='View My Tasks'
                  buttonAction={() => history.push(ROUTES.MYTASK)}
                  dismissAction={onClickDismiss}
                  className='overdue-card'
                  backgroundUrl={imageSource('overdue_background')}
                />
              )}

              {isShowNotificationCard && (!loading || filteredNotifications?.length > 0) && (
                <InboxCard
                  iconName='notification-inbox'
                  title='Enable notifications and Stay in the Loop!'
                  text={ENABLE_NOTIFICATIONS_TEXT}
                  buttonTitle='Enable Notifications'
                  buttonAction={onEnableNotification}
                  dismissAction={onClickNoEnableNotification}
                  className='notification-card'
                  backgroundUrl={imageSource('notification_background')}
                />
              )}

              <NotificationList
                notifications={filteredNotifications || []}
                buttonRef={buttonRef}
                mobile={mobile}
                swipedItemId={swipedItemId}
                touchStartX={touchStartX}
                touchEndX={touchEndX}
                isRearranging={navIsRearranging}
                deletingId={deletingId}
                openDropdownId={openDropdownId}
                subDropdownOpen={subDropdownOpen}
                onClickInboxItem={onClickInboxItem}
                onHoverChange={onHoverChange}
                onClickReadIcon={onClickReadIcon}
                onClickDeleteIcon={onClickDeleteIcon}
                handleTouchStart={handleTouchStart}
                handleTouchMove={handleTouchMove}
                handleTouchEnd={handleTouchEnd}
                handleSubDropdownOpen={handleSubDropdownOpen}
                onClickUpdateStatus={onClickUpdateStatus}
                onClickGroup={onClickGroup}
                onClickUpdatePriority={onClickUpdatePriority}
                isRecurringTask={false}
                isTemplateProject={false}
                calendarDate={calendarDate}
                setCalendarDate={setCalendarDate}
                menuItems={menuItems}
                isImageDescription={isImageDescription}
                githubSvgIcon={githubSvgIcon}
                setSubDropdownOpen={setSubDropdownOpen}
                snoozeMenuItems={snoozeMenuItems}
                onClickSnoozeIcon={onClickSnoozeIcon}
                handleClick={handleClick}
                handleTimeChange={handleTimeChange}
                onCancelSnooze={onCancelSnooze}
                onClickSnooze={onClickSnooze}
                dropdownRefCalendar={dropdownRefCalendar}
                onDateChange={onDateChange}
              />
            </InboxMSG>
          )}
        </InboxContainer>
      </AppLayout>
      <Modal open={deleteModelOpen} onClose={closeDeleteModel} maxWidth={'338px'}>
        <DeleteModal
          onClose={closeDeleteModel}
          loading={buttonLoading}
          isArchive={true}
          onOk={clearAllMessages}
          modalTitle='Archive all notifications?'
          description='Are you sure you want to archive all notifications?'
        />
      </Modal>
      <Modal open={isOpenConfirmationModal} onClose={closeConfirmationModal} maxWidth={'334px'}>
        <ConfirmationModal
          loading={confirmationLoading === 'ok'}
          cancelLoading={confirmationLoading === 'cancel'}
          onOk={onClickConfirm}
          onNo={onClickNo}
          onClose={closeConfirmationModal}
          modalTitle='Uncompleted Subtasks'
          description='Do you want to complete all these subtasks?'
        />
      </Modal>

      {isTaskDetailOpen && !isEmpty(selectedTask?.taskId) && !isEmpty(selectedTask?.projectId) && (
        <>
          <Overlay role='button' onClick={handleCloseTaskDetail}></Overlay>
          <Content>
            <PreviewSection>
              <DetailPreview>
                <TaskDetailPreview
                  taskId={selectedTask?.taskId || ''}
                  projectId={selectedTask?.projectId || ''}
                  handleCloseTaskDetail={handleCloseTaskDetail}
                />
              </DetailPreview>
              <ActionSection>
                <InboxPreviewAction>
                  <IconButton
                    iconName='up-arrow-icon'
                    size={ICON_BUTTON_SIZE.SMALL}
                    variant={ICON_BUTTON_TYPE.TERTIARY}
                    onClick={() => handleArrowClick('Backward')}
                    isDisabled={taskDetails?.id !== selectedTask?.taskId || buttonDisable.backward}
                  />
                  <IconButton
                    iconName='down-arrow-icon'
                    size={ICON_BUTTON_SIZE.SMALL}
                    variant={ICON_BUTTON_TYPE.TERTIARY}
                    onClick={() => handleArrowClick('Forward')}
                    isDisabled={taskDetails?.id !== selectedTask?.taskId || buttonDisable.forward}
                  />
                </InboxPreviewAction>
                {selectedTask && typeof selectedTaskIndex === 'number' && (
                  <InboxActionButtons
                    item={selectedTask}
                    index={selectedTaskIndex}
                    isTaskDetailPreview={true}
                    mobile={mobile}
                    snoozeMenuItems={snoozeMenuItems}
                    onClickReadIcon={onClickReadIcon}
                    onClickDeleteIcon={onClickDeleteIcon}
                    onClickSnoozeIcon={onClickSnoozeIcon}
                    handleClick={handleClick}
                    handleTimeChange={handleTimeChange}
                    onCancelSnooze={onCancelSnooze}
                    onClickSnooze={onClickSnooze}
                    dropdownRefCalendar={dropdownRefCalendar}
                    onDateChange={onDateChange}
                  />
                )}
              </ActionSection>
            </PreviewSection>
          </Content>
        </>
      )}
    </>
  );
};

export default observer(Inbox);
